import React, { FC, useState } from 'react';
import { SubdivisionContext } from 'common/context/subdivision/subdivision.context';

export interface IComponentProps {
  children: React.ReactNode;
}

export const SubdivisionProvider: FC<IComponentProps> = ({ children }) => {
  const [parentId, setParentId] = useState<number | undefined>(undefined);
  const [openSubdivisionCreateCard, setOpenSubdivisionCreateCard] = useState<boolean>(false);

  return (
    <SubdivisionContext.Provider
      value={{
        parentId,
        setParentId,
        openSubdivisionCreateCard,
        setOpenSubdivisionCreateCard,
      }}
    >
      {children}
    </SubdivisionContext.Provider>
  );
};
